
import { useStore } from "vuex";
import { defineComponent, ref } from "vue";
import useUpdateSW from "@/composables/updateSW";
import UpdateExists from "@/components/shared/InfoPanel/UpdateExists.vue";
import VersionInfo from "@/components/shared/InfoPanel/VersionInfo.vue";
import DefaultContent from "@/components/shared/InfoPanel/DefaultContent.vue";
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";
import CommunityLinks from "./CommunityLinks.vue";

export default defineComponent({
  components: {
    UpdateExists,
    VersionInfo,
    DefaultContent,
    GenericPanel,
    GenericButton,
    CommunityLinks,
  },
  name: "InfoPanel",
  setup() {
    const { updateExists, refreshApp } = useUpdateSW();
    const store = useStore();
    const showVersionInfo = ref<boolean>(false);
    const showInfo = (category: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "updateInfoPanel",
        data: { category },
      });
    };
    const reload = () => {
      window.location.reload();
    };
    return {
      state: store.state,
      showVersionInfo,
      showInfo,
      updateExists,
      refreshApp,
      reload,
    };
  },
});
